import { DateTime } from "luxon";
import { RecalledValue } from "./RecalledValue";
import { RecallType } from "./RecallType";

export class DayRecalledValue extends RecalledValue {
    time: DateTime;

    constructor(time: DateTime) {
        super();
        this.time = time;
    }

    evaluateProperty(
        mode: RecallType,
        property: string,
        parameters: string[],
    ): string | RecalledValue {
        switch (property) {
            case "code":
                return this.toCode();
            case "text":
                return this.toText();
            default:
                return this;
        }
    }

    toCode(): string {
        if (this.time == null) return "";
        return this.time.day.toString();
    }

    toText(): string {
        if (this.time == null) return "";
        return this.time.toFormat("ccccc");
    }
}
